"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RPCJSONService = void 0;
const tsyringe_1 = require("tsyringe");
const required_1 = require("../../../../helpers/required/required");
const payloadService_1 = require("../payloadService/payloadService");
const httpService_1 = require("../../../utils/services/httpService/httpService");
const proxyWalletService_1 = require("../proxyWalletService/proxyWalletService");
let RPCJSONService = class RPCJSONService {
    constructor(payloadService, httpService, proxyWalletService) {
        this.payloadService = payloadService;
        this.httpService = httpService;
        this.proxyWalletService = proxyWalletService;
        /**
         * It signs payload with messaging wallet and send rpc call
         * @param {string} endpoint
         * @param rpcMethodName
         * @param params
         * @returns {Promise<{jsonrpc: number; id: string; result?: resultType}>}
         * @constructor
         */
        this.signedRPCCall = (endpoint, rpcMethodName, params) => __awaiter(this, void 0, void 0, function* () {
            required_1.requiredDefined(endpoint, 'endpoint should be defined');
            required_1.requiredDefined(rpcMethodName, 'method should be defined');
            required_1.requiredDefined(params, 'params should be defined');
            const signedPayload = yield this.payloadService.hydratePayloadParameters(params);
            const httpRequest = this.prepareRPCRequest(signedPayload, rpcMethodName);
            const RPCRes = yield this.httpService.fetch(endpoint, httpRequest);
            if (RPCRes.error) {
                throw RPCRes.error;
            }
            if (RPCRes.result) {
                try {
                    RPCRes.result = (typeof (RPCRes.result) === 'string') ? JSON.parse(RPCRes.result) : RPCRes.result;
                }
                catch (e) {
                    console.error('result is not a json');
                }
            }
            return RPCRes.result;
        });
        this.prepareRPCRequest = (params, rpcMethodName) => {
            return {
                method: 'POST',
                data: {
                    jsonrpc: '2.0',
                    params,
                    method: rpcMethodName,
                    id: Date.now().toString()
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        };
    }
};
RPCJSONService = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [payloadService_1.PayloadService, httpService_1.HttpService, proxyWalletService_1.ProxyWalletService])
], RPCJSONService);
exports.RPCJSONService = RPCJSONService;
//# sourceMappingURL=RPCJSONService.js.map